import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Collapse,
    Input,
    Card,
    Form,
    DatePicker,
    Button,
    Switch,
    message,
    Upload,
    Image,
    Tooltip,
    Modal,
    Spin 
} from "antd";
import {
    PlusOutlined,
    MinusOutlined,
    LoadingOutlined,
    SearchOutlined,
    CopyOutlined,
    FormOutlined,
    EyeOutlined,
    CalendarOutlined,
    InfoCircleFilled
} from "@ant-design/icons";
import * as Diff from 'diff';
import * as getSuggestionService from "../../services/getSuggestion";
import { useDispatch } from "react-redux";
import Upload1 from "./uploadMultistep";
import axios from "axios";
import * as FooterLogoService from "../../services/FooterLogo";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { MEDIA_UPLOAD_URL } from "../../Helper";
import 'suneditor/dist/css/suneditor.min.css';
import SunEditor from 'suneditor-react';
import SkeletonIndustryStandard from "./SkeletonIndustryStandard";
import AILoader from "../../components/AILoader";
import TripleToggle from "../../components/trippleToggle/trippleToggle";
import {
    align,
    font,
    fontColor,
    fontSize,
    formatBlock,
    hiliteColor,
    horizontalRule,
    lineHeight,
    list,
    paragraphStyle,
    table,
    template,
    textStyle,
    image,
    link

} from "suneditor/src/plugins";
import ReactDOMServer from "react-dom/server";
import { checkGrammar } from '../../services/grammarCheckService';
const { Panel } = Collapse;


function CommonFourthStep({ reportType, props }) {
    var dispatch = useDispatch();
    const [editorState1, setEditorState1] = useState("");
    const [editorState2, setEditorState2] = useState("");
    const [editorState3, setEditorState3] = useState("");
    const [editorState4, setEditorState4] = useState("");
    const [editorState5, setEditorState5] = useState("");
    const [editorState6, setEditorState6] = useState("");
    const [editorState7, setEditorState7] = useState("");
    const [editorState8, setEditorState8] = useState("");
    const [editorState9, setEditorState9] = useState("");
    const [editorState10, setEditorState10] = useState("");
    const [editorState11, setEditorState11] = useState("");
    const [editorState12, setEditorState12] = useState("");
    const [editorState13, setEditorState13] = useState("");
    const [sidebarState, setsidebarState] = useState();
    const [loading, setLoading] = useState(false);
    const [grammarCheckLoading, setGrammarCheckLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState();
    const [footerLogo, setFooterLogo] = useState([]);
    const [selectedlogs, setselectedLogos] = useState([]);
    const [sign, setSign] = useState([]);
    const [form] = Form.useForm();
    const [modalIndustry, setModalIndustry] = useState(false);
    const [industryContent, setindustryContent] = useState("");
    const [search, setSearch] = useState("");
    const [filterStandards, setFilterStandards] = useState([]);
    const [initialValues, setInitialValues] = useState({});
    const [currentValues, setCurrentValues] = useState({});
    const musicBrainzIcon = ReactDOMServer.renderToStaticMarkup('Spell Check');

    useEffect(() => {
        if (props.values) {
            setInitialValues(props.values);
        }
    }, [props.values]);

    useEffect(() => {
        if (props.values) {
            setCurrentValues(props.values);
        }
    }, []);

    const getFieldBgColor = (fieldName) => {
        if (props.editMode) {
            return '#ffffff'; // Always white in edit mode
        }
        const initial = initialValues[fieldName];
        const current = currentValues[fieldName];

        if (initial && initial === current) {
            return '#f0f0f0'; // grey if prefilled and unchanged
        }
        return '#ffffff'; // white otherwise
    };

    const handleClick = (item1) => {
        setModalIndustry(true);
        sidebarState.filter((item) =>
            item.id === item1 ? setindustryContent(item) : ""
        );
    };

    const takefileList = (list) => {
        if (props.takefileList) {
            props.takefileList(list);
        } else if (props.handleFill) {
            props.handleFill({ attachments: list });
        } else {
            props.values.attachments = list;
        }
    };
    const onEditorStateChange1 = (editorData) => {
        setEditorState1(editorData);
        props.values.claim_history_comments = editorData;
        props.handleEditor(editorData,
            "claim_history_comments"
        );
    };

    const onEditorStateChange2 = (editorData) => {
        setEditorState2(editorData);
        props.values.observation_comments = editorData;
        props.handleEditor(
            editorData,
            "observation_comments"
        );
    };

    const onEditorStateChange3 = (editorData) => {
        setEditorState3(editorData);
        props.values.applicable_field_text = editorData;
        props.handleEditor(
            editorData,
            "applicable_field_text"
        );
    };

    const onEditorStateChange4 = (editorData) => {
        setEditorState4(editorData);
        props.values.industry_standards_text = editorData;
        props.handleEditor(
            editorData,
            "industry_standards_text"
        );
    };

    const onEditorStateChange5 = (editorData) => {
        setEditorState5(editorData);
        props.values.conclusion_text = editorData;
        props.handleEditor(
            editorData,
            "conclusion_text"
        );
    };
    const noAction = (editorData) => {
        console.warn(editorData);
    };

    const onEditorStateChange6 = (editorData) => {
        setEditorState6(editorData);
        props.values.cause_text = editorData;
        props.handleEditor(
            editorData,
            "cause_text"
        );
    };

    const onEditorStateChange7 = (editorData) => {
        setEditorState7(editorData);
        props.values.conf_comment = editorData;
        props.handleEditor(
            editorData,
            "conf_comment"
        );
    };

    const onEditorStateChange8 = (editorData) => {
        setEditorState8(editorData);
        props.values.footer_text = editorData;
        props.handleEditor(
            editorData,
            "footer_text"
        );
    };

    const onEditorStateChange9 = (editorData) => {
        setEditorState9(editorData);
        props.values.private_notes = editorData;
        props.handleEditor(
            editorData,
            "private_notes"
        );
    };
    const onEditorStateChange10 = (editorData) => {
        setEditorState10(editorData);
        props.values.manufacturing_issue = editorData;
        props.handleEditor(
            editorData,
            "manufacturing_issue"
        );
    };
    const onEditorStateChange11 = (editorData) => {
        setEditorState11(editorData);
        props.values.site_rel_issue = editorData;
        props.handleEditor(
            editorData,
            "site_rel_issue"
        );
    };
    const onEditorStateChange12 = (editorData) => {
        setEditorState12(editorData);
        props.values.perfo_rel_issue = editorData;
        props.handleEditor(
            editorData,
            "perfo_rel_issue"
        );
    };
    const onEditorStateChange13 = (editorData) => {
        setEditorState13(editorData);
        props.values.insta_rel_issue = editorData;
        props.handleEditor(
            editorData,
            "insta_rel_issue"
        );
    };

    // format long text to html
    const formatPlainTextToHTML = (plainText) => {
        if (!plainText) return '';
        
        let htmlContent = '';
        const lines = plainText.split('\n');
        let inParagraph = false;
        let inTable = false;
        let tableRows = [];
        let isHeaderRow = false;
        
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i].trim();
            if (!line) continue;
            
            // Check for table rows (contains | characters)
            if (line.includes('|') && (line.includes('---') || line.match(/\|[^|]+\|[^|]+\|/))) {
                if (!inTable) {
                    // Start of a table
                    if (inParagraph) {
                        htmlContent += '</p>';
                        inParagraph = false;
                    }
                    inTable = true;
                    tableRows = [];
                    isHeaderRow = true;
                }
                
                // Clean up table row
                const cleanRow = line.replace(/^\||\|$/g, '').trim();
                const cells = cleanRow.split('|').map(cell => cell.trim());
                
                if (line.includes('---') && cells.every(cell => cell.replace(/-/g, '').trim() === '')) {
                    // This is a separator line, next row will be data
                    isHeaderRow = false;
                } else {
                    tableRows.push({ cells, isHeader: isHeaderRow });
                    isHeaderRow = false;
                }
                
                continue;
            } else if (inTable) {
                // End of table - process collected rows
                htmlContent += convertTableToHTML(tableRows);
                inTable = false;
                tableRows = [];
            }
            
            // Check for headers
            if (line.startsWith('### ')) {
                if (inParagraph) {
                    htmlContent += '</p>';
                    inParagraph = false;
                }
                htmlContent += `<h3>${line.substring(4)}</h3>`;
            } 
            else if (line.startsWith('## ')) {
                if (inParagraph) {
                    htmlContent += '</p>';
                    inParagraph = false;
                }
                htmlContent += `<h2>${line.substring(3)}</h2>`;
            } 
            else if (line.startsWith('# ')) {
                if (inParagraph) {
                    htmlContent += '</p>';
                    inParagraph = false;
                }
                htmlContent += `<h1>${line.substring(2)}</h1>`;
            }
            else {
                // Regular text line
                if (!inParagraph) {
                    htmlContent += '<p>';
                    inParagraph = true;
                } else if (i > 0 && lines[i-1].trim()) {
                    htmlContent += '<br>';
                }
                htmlContent += line;
            }
        }
        
        // Close any open table
        if (inTable) {
            htmlContent += convertTableToHTML(tableRows);
        }
        
        // Close any open paragraph
        if (inParagraph) {
            htmlContent += '</p>';
        }
        
        // Apply text formatting
        htmlContent = htmlContent
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.*?)\*/g, '<em>$1</em>');
        
        return htmlContent;
    };

    // Helper function to convert table data to HTML
    const convertTableToHTML = (tableRows) => {
        if (!tableRows.length) return '';
        
        let tableHTML = '<table style="border-collapse: collapse; width: 100%; margin: 15px 0;">';
        
        tableRows.forEach((row, index) => {
            tableHTML += '<tr>';
            row.cells.forEach(cell => {
                const tag = row.isHeader ? 'th' : 'td';
                const styles = row.isHeader 
                    ? 'style="background-color: #f0f0f0; border: 1px solid #ccc; padding: 8px; font-weight: bold;"'
                    : 'style="border: 1px solid #ccc; padding: 8px;"';
                
                tableHTML += `<${tag} ${styles}>${cell}</${tag}>`;
            });
            tableHTML += '</tr>';
        });
        
        tableHTML += '</table>';
        return tableHTML;
    };

    const extractPlainText = (html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        const scripts = tempDiv.getElementsByTagName('script');
        const styles = tempDiv.getElementsByTagName('style');
        
        Array.from(scripts).forEach(script => script.remove());
        Array.from(styles).forEach(style => style.remove());
        
        let text = tempDiv.textContent || tempDiv.innerText || '';
        
        text = text
            .replace(/\s+/g, ' ')
            .replace(/[^\x00-\x7F]/g, '')
            .replace(/[”“"']/g, '')
            .trim();
        
        return text;
    }

    const spinnerJSX = (
    <div style={{ 
        padding: '60px 20px', 
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '250px'
    }}>
    <AILoader/>

    </div>
    );
    const generateDiffHTMLForSunEditor = (originalText, correctedText) => {
    // First, clean any existing highlighting from original/corrected text
    const cleanHTML = (html) => {
        return html
        .replace(/background-color:\s*rgb\([^)]+\);?/gi, '')
        .replace(/style=""/g, '')
        .replace(/style="\s*"/g, '');
    };
    
    const cleanedOriginal = cleanHTML(originalText);
    const cleanedCorrected = cleanHTML(correctedText);
    
    const diff = Diff.diffWords(cleanedOriginal, cleanedCorrected);
    
    let html = '';
    
    diff.forEach((part) => {
        if (part.removed) {
        return;
        }
        
        if (part.added) {
        // Split by HTML tags
        const segments = part.value.split(/(<[^>]+>)/g);
        
        segments.forEach((segment) => {
            if (!segment) return;
            
            if (segment.match(/^<[^>]+>$/)) {
            // It's an HTML tag
            html += segment;
            } else if (segment.trim()) {
            // It's text - highlight the whole word/phrase
            html += `<span style="background-color: #9eeb08; border-bottom: 2px solid #28a745; font-weight: 600; padding: 1px 3px; color: #000000;">${segment}</span>`;
            } else {
            // Just whitespace
            html += segment;
            }
        });
        } else {
        html += part.value;
        }
    });
    
    return html;
    };
    const customModalPlugin = {
        name: "customModal",
        display: "command",
        title: "Spell Check",
        buttonClass: "custom-spell-check-btn",
        innerHTML: musicBrainzIcon,
        add: function (core, targetElement) {
            const context = core.context;
            context.customModal = {
                targetButton: targetElement,
                core: core 
            };
        },
        action: function () {
            const context = this.context;
            if (!context || !context.customModal || !context.customModal.core) {
                console.error('Core editor instance not found');
                return;
            }
            
            const core = context.customModal.core;
            
            const htmlContent = core.getContents();
            console.log("HTML content:", htmlContent);
            const plainText =htmlContent;
            
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = plainText;
            const textOnly = tempDiv.textContent || tempDiv.innerText || '';

            if (!textOnly.trim()) {
                setModalIndustry(true);
                setindustryContent({
                    title: "Spell Check",
                    description: <p className='text-center'>Please add some text to check grammar.</p>
                });
                return;
            }

            setModalIndustry(true);
            setindustryContent({
            title: "Spell Check",
            description: (
                <div className="grammerModalContent" style={{display:'flex', justifyContent:'center', alignItems:'center', minHeight:'200px'}}>
                {spinnerJSX}
                </div>
            )
            });
 
            
            dispatch(checkGrammar(plainText))
            .then((response) => {
                console.log("Full API response:", response);
                console.log("API response data:", response.data);
                
                // CORRECTED: Extract data properly
                const apiData = response?.data?.data ?? {};
                const originalText = typeof apiData.original === 'string' ? apiData.original : plainText;
                const correctedText = typeof apiData.corrected === 'string' ? apiData.corrected : originalText;
                
                setindustryContent({
                    title: (
                        <div
                        style={{
                            backgroundColor: "#0A497B",
                            color: "white",
                            textAlign: "center",
                            width:"100%",
                            padding: "12px 0",
                        }}
                        >
                        Spell Check Results
                        </div>
                    ),
                    description: (
                    <div className="grammerModalContent" style={{ padding: 12 }}>
                    <div className="grammerModal">
                        <Row gutter={16}>
                        {/* Original Text */}
                        <Col xs={24} md={12} xl={12}>
                            <div className="textSection">
                            <h4 className="contentHeading" style={{ 
                                marginBottom: '12px',
                                color: '#333',
                                fontSize: '16px',
                                fontWeight: '600'
                            }}>
                                Original Text
                            </h4>
                            <div style={{
                                border: '1px solid #d9d9d9',
                                borderRadius: '4px',
                                overflow: 'hidden',
                                backgroundColor: '#fafafa'
                            }}>
                                <SunEditor
                                setContents={formatPlainTextToHTML(originalText)}
                                hideToolbar={true}
                                disable={true}
                                setOptions={{
                                    minHeight: "250px",
                                    maxHeight: "400px",
                                    readonly: true,
                                    toolbar: false,
                                }}
                                />
                            </div>
                            </div>
                        </Col>

                        {/* Suggested Correction with Diff Highlighting in SunEditor */}
                        <Col xs={24} md={12} xl={12}>
                            <div className="textSection">
                            <h4 className="contentHeading" style={{ 
                                marginBottom: '12px',
                                color: '#333',
                                fontSize: '16px',
                                fontWeight: '600',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                Suggested Correction
                                <span style={{
                                fontSize: '12px',
                                fontWeight: 'normal',
                                color: '#666',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                                }}>
                                (<span style={{ 
                                    display: 'inline-block',
                                    width: '12px',
                                    height: '12px',
                                    backgroundColor: '#9eeb08',
                                    border: '1px solid #28a745',
                                    borderRadius: '2px'
                                }}></span>
                                <span style={{ color: '#28a745', fontWeight: 'bold' }}>Corrected</span>)
                                </span>
                            </h4>
                            <div style={{
                                border: '1px solid #d9d9d9',
                                borderRadius: '4px',
                                overflow: 'hidden',
                                backgroundColor: '#ffffff'
                            }}>
                                <SunEditor
                                setContents={generateDiffHTMLForSunEditor(originalText, correctedText)}
                                hideToolbar={true}
                                disable={true}
                                setOptions={{
                                    minHeight: "250px",
                                    maxHeight: "400px",
                                    readonly: true,
                                    toolbar: false,
                                }}
                                />
                            </div>
                            </div>
                        </Col>
                        </Row>
                    </div>

                    <div className="sectionFooter" style={{ 
                        display: 'flex', 
                        gap: '8px', 
                        justifyContent: 'flex-end', 
                        marginTop: 16,
                        paddingTop: 16,
                        borderTop: '1px solid #f0f0f0'
                    }}>
                        <button
                        onClick={() => window.applyGrammarCorrection && window.applyGrammarCorrection()}
                        className="submitBtn"
                        >
                        Apply Suggestions
                        </button>
                        <button
                        onClick={() => window.closeGrammarModal && window.closeGrammarModal()}
                        className="btn link-button"
                        >
                        Cancel
                        </button>
                    </div>
                    </div>
                    ),
                });
            
                
                  window.applyGrammarCorrection = () => {
                    try {
                    const formattedContent = formatPlainTextToHTML(correctedText);
                    // Use core from earlier captured variable (we still reference `core` here)
                    core.setContents(formattedContent);
                    } catch (err) {
                    console.error('Failed to apply Spell correction:', err);
                    } finally {
                    setModalIndustry(false);
                    cleanupGrammarFunctions();
                    }
                };
       
                window.closeGrammarModal = () => {
                    setModalIndustry(false);
                    cleanupGrammarFunctions();
                };
            })
        .catch((error) => {
          console.error("Spell check error:", error);
          let errorMessage = "Please try again later.";

          if (error?.response?.data) {
            // try to extract messages or fallback to server text
            if (error.response.data.messages) {
              errorMessage = Object.values(error.response.data.messages).flat().join(", ");
            } else if (error.response.data.message) {
              errorMessage = error.response.data.message;
            } else {
              errorMessage = JSON.stringify(error.response.data);
            }
          } else if (error?.message) {
            errorMessage = error.message;
          }

          setindustryContent({
            title: "Spell Check Error",
            description: (
              <div style={{ padding: 12 }}>
                <p style={{ color: '#ff4d4f' }}>Error: {errorMessage}</p>
                <button
                  onClick={() => {
                    setModalIndustry(false);
                    cleanupGrammarFunctions();
                  }}
                  style={{
                    backgroundColor: '#f5f5f5',
                    color: '#333',
                    border: '1px solid #d9d9d9',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    marginTop: '8px',
                  }}
                >
                  Close
                </button>
              </div>
            ),
          });

          // ensure we expose a close function so the UI can always be closed
          window.closeGrammarModal = () => {
            setModalIndustry(false);
            cleanupGrammarFunctions();
          };
        });
        }
        
    };

    const cleanupGrammarFunctions = () => {
        delete window.applyGrammarCorrection;
        delete window.closeGrammarModal;
    };

    const SunEditorOpts = {
        showPathLabel: false,
        imageMultipleFile: true,
        imageWidth: '150px',
        imageHeight: '150px',
        height: "auto",
        minHeight: "200px",
        requestHeaders: {
            "X-Sample": "sample"
        },
        plugins: [
            align,
            font,
            fontColor,
            fontSize,
            formatBlock,
            hiliteColor,
            horizontalRule,
            lineHeight,
            list,
            paragraphStyle,
            table,
            template,
            textStyle,
            image,
            link,
            customModalPlugin
        ],
        buttonList: [
            ["undo", "redo"],
            ["font", "fontSize", "formatBlock"],
            ["paragraphStyle"],
            [
                "bold",
                "underline",
                "italic",
                "strike",
                "subscript",
                "superscript"
            ],
            ["fontColor", "hiliteColor"],
            ["removeFormat"],
            ["align", "horizontalRule", "lineHeight"],
            ["outdent", "indent"], ["list"],
            ["table", "link", "image"],
            ["fullScreen", "showBlocks", "preview",],
            ["customModal"],
        ],
        formats: ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"],
        font: [
            "Arial",
            "Calibri",
            "Comic Sans",
            "Courier",
            "Garamond",
            "Georgia",
            "Impact",
            "Lucida Console",
            "Palatino Linotype",
            "Segoe UI",
            "Tahoma",
            "Times New Roman",
            "Trebuchet MS",
            "Roboto"
        ]
    };

    const onImageUploadBefore = (files, info, uploadHandler) => {
        const formData = new FormData()
        const config = {
            headers: {
                "content-type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
            },
        };
        formData.append('file', files[0])
        axios.post(MEDIA_UPLOAD_URL, formData, config)
            .then((res) => {
                const response = {
                    // The response must have a "result" array.
                    "result": [
                        {
                            "url": res.data.source_url,
                            "name": files[0].name,
                            "size": files[0].size
                        },
                    ]
                }
                uploadHandler(response)
            })
    }
    const getSuggestion = (label, category) => {
        setLoading(true);
        let suggestiondata = {
            label: label,
            category: category,
        };
        dispatch(getSuggestionService.getindStandard(suggestiondata))
            .then((res) => {
                setsidebarState(res);
                setLoading(false);
            })
            .catch((err) => {
                // Extract and display a meaningful error message
                let errorMessage;

                if (err.response) {
                    // The request was made and the server responded with a status code outside of the 2xx range
                    errorMessage = `Error ${err.response.status}: ${err.response.data.message || err.response.statusText}`;
                } else if (err.request) {
                    // The request was made but no response was received
                    errorMessage = "No response received from the server. Please check your network connection.";
                } else {
                    // Something else happened while setting up the request
                    errorMessage = `An unexpected error occurred: ${err.message}`;
                }

                // Display the error message in an alert or use a UI notification component
                alert(errorMessage);
            });
    };






    const fetchData = (params = {}) => {
        setLoading(true);
        dispatch(FooterLogoService.getLogos())
            .then((res) => {
                setFooterLogo(res);
                setLoading(false);
            })
            .catch((err) => {
                console.info("Get Error Edit State...");
                setLoading(false);
            });
    };

    useEffect(() => {
        props.values.claim_history_comments
            ? setEditorState1(props.values.claim_history_comments)
            : setEditorState1("");
        props.values.observation_comments
            ? setEditorState2(props.values.observation_comments)
            : setEditorState2("");
        props.values.applicable_field_text
            ? setEditorState3(props.values.applicable_field_text)
            : setEditorState3("");
        props.values.industry_standards_text
            ? setEditorState4(props.values.industry_standards_text)
            : setEditorState4("");
        props.values.conclusion_text
            ? setEditorState5(props.values.conclusion_text)
            : setEditorState5("");
        props.values.cause_text
            ? setEditorState6(props.values.cause_text)
            : setEditorState6("");
        props.values.conf_comment
            ? setEditorState7(props.values.conf_comment)
            : setEditorState7("");
        props.values.footer_text
            ? setEditorState8(props.values.footer_text)
            : setEditorState8("");
        props.values.private_notes
            ? setEditorState9(props.values.private_notes)
            : setEditorState9("");
        props.values.manufacturing_issue
            ? setEditorState10(props.values.manufacturing_issue)
            : setEditorState10("");
        props.values.site_rel_issue
            ? setEditorState11(props.values.site_rel_issue)
            : setEditorState11("");
        props.values.perfo_rel_issue
            ? setEditorState12(props.values.perfo_rel_issue)
            : setEditorState12("");
        props.values.insta_rel_issue
            ? setEditorState13(props.values.insta_rel_issue)
            : setEditorState13("");
        setselectedLogos(props.values?.footerLogo);
        setSign(props.values?.signId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.values.footerLogo]);

    const normFile = (e) => {
        console.log("Upload event:", e);

        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };
    const sendTextToEditor = (text, label) => {
        if (label === "claim-history") {
            setEditorState1(editorState1 + text);
            onEditorStateChange1(editorState1 + text);


        } else if (label === "observations_and_comments") {
            setEditorState2(editorState2 + text);
            onEditorStateChange2(editorState2 + text);

        } else if (label === "applicable-field-tests") {
            setEditorState3(editorState3 + text);
            onEditorStateChange3(editorState3 + text);

        } else if (label === "industry_standards") {
            setEditorState4(editorState4 + text);
            onEditorStateChange4(editorState4 + text);

        } else if (label === "conclusion") {
            setEditorState5(editorState5 + text);
            onEditorStateChange5(editorState5 + text);

        } else if (label === "cause") {
            setEditorState6(editorState6 + text);
            onEditorStateChange6(editorState6 + text);

        } else if (label === "confidential-information") {
            setEditorState7(editorState7 + text);
            onEditorStateChange7(editorState7 + text);

        } else if (label === "footer-text") {
            setEditorState8(editorState8 + text);
            onEditorStateChange8(editorState8 + text);

        } else if (label === "private-notes") {
            setEditorState9(editorState9 + text);
            onEditorStateChange9(editorState9 + text);
        }
        else if (label === "manufacturing_issue") {
            setEditorState10(editorState10 + text);
            onEditorStateChange10(editorState10 + text);
        }
        else if (label === "site_rel_issue") {
            setEditorState11(editorState11 + text);
            onEditorStateChange11(editorState11 + text);
        }
        else if (label === "perfo_rel_issue") {
            setEditorState12(editorState12 + text);
            onEditorStateChange12(editorState12 + text);
        }
        else if (label === "insta_rel_issue") {
            setEditorState13(editorState13 + text);
            onEditorStateChange13(editorState13 + text);
        }
    };




    const handleChange = (e) => {
        //setData(e.target.value);
        console.warn("input", e);
        console.log(`selected ${e.target.value}`);
    };

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

        if (!isJpgOrPng) {
            message.error("You can only upload JPG/PNG file!");
        }

        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
            message.error("Image must smaller than 2MB!");
        }

        return isJpgOrPng && isLt2M;
    };

    const handleChangeImage = (info) => {
        if (info.file.status === "uploading") {
            setLoading(true);
            return;
        }

        if (info.file.status === "done") {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, (url) => {
                setLoading(false);
                setImageUrl(url);
                props.values.signurl = url;
            });
        }
    };

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </div>
    );

    const uploadImage = async (options) => {
        const { onSuccess, onError, file } = options;

        const fmData = new FormData();
        const config = {
            headers: {
                "content-type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
            },
        };
        fmData.append("file", file);
        try {
            const res = await axios.post(MEDIA_UPLOAD_URL, fmData, config);
            onSuccess("Ok");
            setSign(res);
            console.log("server res: ", res);
            props.values.signature = res?.data?.id;
            console.log('props.values.signature', props.values.signature);
        } catch (err) {
            console.log("Eroor: ", err);
            const error = new Error("Some error");
            onError({ err });
            console.warn(error);
        }
    };

    useEffect(() => {
        setselectedLogos(props.values?.footerLogo)
        setImageUrl(props.values?.signurl)
        fetchData();
        props.values.claim_history_comments ? setEditorState1(props.values.claim_history_comments) : setEditorState1("");
        props.values.observation_comments ? setEditorState2(props.values.observation_comments) : setEditorState2("");
        props.values.applicable_field_text ? setEditorState3(props.values.applicable_field_text) : setEditorState3("");
        props.values.industry_standards_text ? setEditorState4(props.values.industry_standards_text) : setEditorState4("");
        props.values.conclusion_text ? setEditorState5(props.values.conclusion_text) : setEditorState5("");
        props.values.cause_text ? setEditorState6(props.values.cause_text) : setEditorState6("");
        props.values.conf_comment ? setEditorState7(props.values.conf_comment) : setEditorState7("");
        props.values.footer_text ? setEditorState8(props.values.footer_text) : setEditorState8("");
        props.values.private_notes ? setEditorState9(props.values.private_notes) : setEditorState9("");
        props.values.manufacturing_issue ? setEditorState10(props.values.manufacturing_issue) : setEditorState10("");
        props.values.site_rel_issue ? setEditorState11(props.values.site_rel_issue) : setEditorState11("");
        props.values.perfo_rel_issue ? setEditorState12(props.values.perfo_rel_issue) : setEditorState12("");
        props.values.insta_rel_issue ? setEditorState13(props.values.insta_rel_issue) : setEditorState13("");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        console.info('Useffect Called')
        if (sidebarState) {
            const filteredData = sidebarState.filter((entry) =>
                entry?.title?.toLowerCase().includes(search.toLowerCase())
            );
            setFilterStandards(filteredData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const DateFormat = "MM-DD-YYYY";

    return (
        <>
            <Form
                name="report"
                form={form}
                autoComplete="off"
                layout="vertical"
                onChange={handleChange}
            >
                <Card className="reportCard">
                    <div className="reportCardBody">
                        <div className="formSection">
                            <div className="CollapseSection">
                                <div className="customObservationPanel">
                                    <Row gutter={16}>
                                        <Col xs={24} md={16} xl={16}>
                                            <Collapse
                                                defaultActiveKey={
                                                    props.values.stepFourTogg
                                                        ? props.values.stepFourTogg
                                                        : ["6", "7", "8"]
                                                }
                                                onChange={props.handleChange("stepFourTogg")}
                                                className="reportCollapse"
                                                expandIcon={({ isActive }) =>
                                                    isActive ? (
                                                        <MinusOutlined className="custom-icon" />
                                                    ) : (
                                                        <PlusOutlined className="custom-icon" />
                                                    )
                                                }
                                                ghost
                                            >
                                                <Panel header="Inspection Information" key={6}>
                                                    <Row gutter={16}>
                                                        <Col xs={24} md={24} xl={24}>
                                                            <div className="formGroup">

                                                                <Form.Item
                                                                    label="Sending Sample?"
                                                                    name="sending_samples"
                                                                >
                                                                    {console.warn("tripleToggle")}
                                                                    <TripleToggle
                                                                        value={props.values.sending_samples}
                                                                        onToggle={props.handleChange('sending_samples')}
                                                                    />
                                                                </Form.Item>
                                                            </div>

                                                            {props.isOpen.sendingSampleField === true && props.values.sending_samples === 'Yes' ? (
                                                                <div id="myDiv2" className="hidden-section">
                                                                    <Row gutter={16}>
                                                                        <Col xs={24} md={8} xl={8}>
                                                                            <div className="formGroup">
                                                                                <Form.Item
                                                                                    label="Shipping Company"
                                                                                    name="shipping_company"
                                                                                >
                                                                                    <Input
                                                                                        placeholder="Shipping Company"
                                                                                        className="formControl"
                                                                                        type="text"
                                                                                        onChange={props.handleChange(
                                                                                            "shipping_company"
                                                                                        )}
                                                                                        style={{ backgroundColor: getFieldBgColor('shipping_company') }}
                                                                                        defaultValue={
                                                                                            props.values.shipping_company
                                                                                        }
                                                                                    />
                                                                                </Form.Item>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={24} md={8} xl={8}>
                                                                            <div className="formGroup">
                                                                                <Form.Item
                                                                                    label="Tracking Number"
                                                                                    name="tracking_number"
                                                                                >
                                                                                    <Input
                                                                                        placeholder="Tracking Number"
                                                                                        className="formControl"
                                                                                        onChange={props.handleChange(
                                                                                            "tracking_number"
                                                                                        )}
                                                                                        style={{ backgroundColor: getFieldBgColor('tracking_number') }}
                                                                                        defaultValue={
                                                                                            props.values.tracking_number
                                                                                        }
                                                                                    />
                                                                                </Form.Item>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={24} md={8} xl={8}>
                                                                            <div className="formGroup">
                                                                                <Form.Item
                                                                                    label="Date Shipped"
                                                                                    name="date_shipped"
                                                                                >
                                                                                    <Input.Group compact className="mt-0">
                                                                                        <Input
                                                                                            placeholder="Date Shipped"
                                                                                            className="formControl"
                                                                                            onChange={(e) =>
                                                                                                props.handleDateformate(
                                                                                                    e,
                                                                                                    'date_shipped',
                                                                                                    'text'
                                                                                                )
                                                                                            }
                                                                                            style={{ backgroundColor: getFieldBgColor('date_shipped') }}
                                                                                            value={props.values.date_shipped}
                                                                                            onFocus={() => props.setCalOpen6(!props.calOpen6)}
                                                                                            onKeyUp={() => props.setCalOpen6(false)}
                                                                                            onBlur={() => props.setCalOpen6(false)}
                                                                                        />

                                                                                        <Button
                                                                                            className="btnAddOn"
                                                                                            icon={<CalendarOutlined />}
                                                                                            onClick={() => props.setCalOpen6(!props.calOpen6)}
                                                                                        />
                                                                                    </Input.Group>
                                                                                    <DatePicker
                                                                                        className="formControl dateHide"
                                                                                        format={DateFormat}
                                                                                        open={props.calOpen6}
                                                                                        style={{ visibility: 'hidden', width: 0, backgroundColor: getFieldBgColor('date_shipped') }}
                                                                                        onChange={(e) =>
                                                                                            props.handleDateformate(
                                                                                                e,
                                                                                                'date_shipped',
                                                                                                'date'
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                </Form.Item>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            ) : (
                                                                ""
                                                            )}
                                                            <Row className="claim-history-section">
                                                                <div className="formGroup">
                                                                    <Form.Item
                                                                        label="Claim History"
                                                                        name="claim_his_togg"
                                                                    >
                                                                        <Switch
                                                                            defaultChecked={
                                                                                props.isOpen.claimHistoryField ===
                                                                                    true &&
                                                                                    props.values.claim_his_togg === true
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            onChange={props.handleChange(
                                                                                "claim_his_togg"
                                                                            )}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                                {props.isOpen.claimHistoryField === true &&
                                                                    props.values.claim_his_togg === true ? (
                                                                    <div className="text-editor-wrapper">

                                                                        <SunEditor

                                                                            onFocus={(event) => {
                                                                                getSuggestion(
                                                                                    "claim-history",
                                                                                    reportType
                                                                                );
                                                                            }}
                                                                            setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                            setOptions={SunEditorOpts}
                                                                            onImageUploadBefore={onImageUploadBefore}
                                                                            setContents={editorState1}
                                                                            onChange={onEditorStateChange1}

                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </Row>
                                                            <Row className="physcial-description-section">
                                                                <div className="formGroup">
                                                                    <Form.Item
                                                                        label="Observations and Physical Description"
                                                                        name="observe_togg"
                                                                    >
                                                                        <Switch
                                                                            defaultChecked={
                                                                                props.isOpen.observationField ===
                                                                                    true &&
                                                                                    props.values.observe_togg === true
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            onChange={props.handleChange(
                                                                                "observe_togg"
                                                                            )}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                                {props.isOpen.observationField === true &&
                                                                    props.values.observe_togg === true ? (
                                                                    <div className="text-editor-wrapper">

                                                                        <SunEditor

                                                                            onFocus={(event) => {
                                                                                getSuggestion(
                                                                                    "observations_and_comments",
                                                                                    reportType
                                                                                );
                                                                            }}
                                                                            setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                            setOptions={SunEditorOpts}
                                                                            onImageUploadBefore={onImageUploadBefore}
                                                                            setContents={editorState2}
                                                                            onChange={onEditorStateChange2}

                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </Row>
                                                            <Row className="field-test-section">
                                                                <div className="formGroup">
                                                                    <Form.Item
                                                                        label="Applicable Field Tests"
                                                                        name="app_field_togg"
                                                                    >
                                                                        <Switch
                                                                            defaultChecked={
                                                                                props.isOpen.applicableField === true &&
                                                                                    props.values.app_field_togg === true
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            onChange={props.handleChange(
                                                                                "app_field_togg"
                                                                            )}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                                {props.isOpen.applicableField === true &&
                                                                    props.values.app_field_togg === true ? (
                                                                    <div className="text-editor-wrapper">
                                                                        <SunEditor

                                                                            onFocus={(event) => {
                                                                                getSuggestion(
                                                                                    "applicable-field-tests",
                                                                                    reportType
                                                                                );
                                                                            }}
                                                                            setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                            setOptions={SunEditorOpts}
                                                                            onImageUploadBefore={onImageUploadBefore}
                                                                            setContents={editorState3}
                                                                            onChange={onEditorStateChange3}

                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </Row>
                                                            <Row className="industry-section">
                                                                <div className="formGroup">
                                                                    <Form.Item
                                                                        label="Industry Standards/Manufacturers Standards/Citations and Resources Cited"
                                                                        name="indus_stand_togg"
                                                                    >
                                                                        <Switch
                                                                            defaultChecked={
                                                                                props.isOpen.industryField === true &&
                                                                                    props.values.indus_stand_togg === true
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            onChange={props.handleChange(
                                                                                "indus_stand_togg"
                                                                            )}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                                {props.isOpen.industryField === true &&
                                                                    props.values.indus_stand_togg === true ? (
                                                                    <div className="text-editor-wrapper">
                                                                        <SunEditor

                                                                            onFocus={(event) => {
                                                                                getSuggestion(
                                                                                    "industry_standards",
                                                                                    reportType
                                                                                );
                                                                            }}
                                                                            setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                            setOptions={SunEditorOpts}
                                                                            onImageUploadBefore={onImageUploadBefore}
                                                                            setContents={editorState4}
                                                                            onChange={onEditorStateChange4}

                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </Row>
                                                            <Collapse
                                                                defaultActiveKey={
                                                                    props.values.stepFourTogg
                                                                        ? props.values.stepFourTogg
                                                                        : ["10"]
                                                                }
                                                                onChange={props.handleChange('stepFourTogg')}
                                                                className="reportCollapse"
                                                                expandIcon={({ isActive }) =>
                                                                    isActive ? (
                                                                        <MinusOutlined className="custom-icon" />
                                                                    ) : (
                                                                        <PlusOutlined className="custom-icon" />
                                                                    )
                                                                }
                                                                ghost
                                                            >
                                                                <Panel header="Manufacturing issues, Site related issues, Performance related issues and Installation related issues" key={10}>
                                                                    {props.values.disable_conclusion && (
                                                                        <div
                                                                            style={{
                                                                                backgroundColor: "#f8f9fa",
                                                                                borderLeft: "4px solid #0A497B",
                                                                                padding: "16px",
                                                                                borderRadius: "4px",
                                                                                fontFamily: "Arial, sans-serif",
                                                                                color: "#333",
                                                                                margin: "16px 0"
                                                                            }}
                                                                        >
                                                                            <p style={{ fontWeight: "bold", color: "#0A497B", marginBottom: "8px" }}>
                                                                                <strong>Note:</strong> For Mohawk claims, the sections for Manufacturing Issues, Site-Related Issues, Performance-Related Issues, Installation-Related Issues, Conclusion and Cause are currently disabled.
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                    <Row className="issues-panel-section">
                                                                        <div className="formGroup">
                                                                            <Form.Item
                                                                                label="Manufacturing issues"
                                                                                name="manufacturing_issue_togg"
                                                                            >
                                                                                <Switch
                                                                                    defaultChecked={
                                                                                        props.isOpen.manuissuesField ===
                                                                                            true &&
                                                                                            props.values.manufacturing_issue_togg === true
                                                                                            && props.values.disable_conclusion !== true
                                                                                            ? true
                                                                                            : false
                                                                                    }
                                                                                    disabled={props.values.disable_conclusion}
                                                                                    onChange={props.handleChange(
                                                                                        "manufacturing_issue_togg"
                                                                                    )}
                                                                                />
                                                                            </Form.Item>
                                                                        </div>
                                                                        {props.isOpen.manuissuesField === true &&
                                                                            props.values.manufacturing_issue_togg === true ? (
                                                                            <div className="text-editor-wrapper">
                                                                                <SunEditor
                                                                                    onFocus={(event) => {
                                                                                        getSuggestion(
                                                                                            "manufacturing_issue",
                                                                                            reportType
                                                                                        );
                                                                                    }}
                                                                                    setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                                    setOptions={SunEditorOpts}
                                                                                    onImageUploadBefore={onImageUploadBefore}
                                                                                    setContents={editorState10}
                                                                                    onChange={onEditorStateChange10}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </Row>
                                                                    <Row className="issues-panel-section">
                                                                        <div className="formGroup">
                                                                            <Form.Item
                                                                                label="Site related issues"
                                                                                name="site_rel_issue_togg"
                                                                            >
                                                                                <Switch
                                                                                    defaultChecked={
                                                                                        props.isOpen.siteissuesField ===
                                                                                            true &&
                                                                                            props.values.site_rel_issue_togg === true
                                                                                            ? true && props.values.disable_conclusion !== true
                                                                                            : false
                                                                                    }
                                                                                    disabled={props.values.disable_conclusion}
                                                                                    onChange={props.handleChange(
                                                                                        "site_rel_issue_togg"
                                                                                    )}
                                                                                />
                                                                            </Form.Item>
                                                                        </div>
                                                                        {props.isOpen.siteissuesField === true &&
                                                                            props.values.site_rel_issue_togg === true ? (
                                                                            <div className="text-editor-wrapper">
                                                                                <SunEditor
                                                                                    onFocus={(event) => {
                                                                                        getSuggestion(
                                                                                            "site_rel_issue",
                                                                                            reportType
                                                                                        );
                                                                                    }}
                                                                                    setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                                    setOptions={SunEditorOpts}
                                                                                    onImageUploadBefore={onImageUploadBefore}
                                                                                    setContents={editorState11}
                                                                                    onChange={onEditorStateChange11}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </Row>
                                                                    <Row className="issues-panel-section">
                                                                        <div className="formGroup">
                                                                            <Form.Item
                                                                                label="Performance related issues"
                                                                                name="perfo_rel_issue_togg"
                                                                            >
                                                                                <Switch
                                                                                    defaultChecked={
                                                                                        props.isOpen.perfoissuesField ===
                                                                                            true &&
                                                                                            props.values.perfo_rel_issue_togg === true
                                                                                            && props.values.disable_conclusion !== true
                                                                                            ? true
                                                                                            : false
                                                                                    }
                                                                                    disabled={props.values.disable_conclusion}
                                                                                    onChange={props.handleChange(
                                                                                        "perfo_rel_issue_togg"
                                                                                    )}
                                                                                />
                                                                            </Form.Item>
                                                                        </div>
                                                                        {props.isOpen.perfoissuesField === true &&
                                                                            props.values.perfo_rel_issue_togg === true ? (
                                                                            <div className="text-editor-wrapper">
                                                                                <SunEditor
                                                                                    onFocus={(event) => {
                                                                                        getSuggestion(
                                                                                            "perfo_rel_issue",
                                                                                            reportType
                                                                                        );
                                                                                    }}
                                                                                    setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                                    setOptions={SunEditorOpts}
                                                                                    onImageUploadBefore={onImageUploadBefore}
                                                                                    setContents={editorState12}
                                                                                    onChange={onEditorStateChange12}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </Row>
                                                                    <Row className="issues-panel-section">
                                                                        <div className="formGroup">
                                                                            <Form.Item
                                                                                label="Installation related issues"
                                                                                name="insta_rel_issue_togg"
                                                                            >
                                                                                <Switch
                                                                                    defaultChecked={
                                                                                        props.isOpen.instaissuesField ===
                                                                                            true &&
                                                                                            props.values.insta_rel_issue_togg === true
                                                                                            && props.values.disable_conclusion !== true
                                                                                            ? true
                                                                                            : false
                                                                                    }
                                                                                    disabled={props.values.disable_conclusion}
                                                                                    onChange={props.handleChange(
                                                                                        "insta_rel_issue_togg"
                                                                                    )}
                                                                                />
                                                                            </Form.Item>
                                                                        </div>
                                                                        {props.isOpen.instaissuesField === true &&
                                                                            props.values.insta_rel_issue_togg === true ? (
                                                                            <div className="text-editor-wrapper">
                                                                                <SunEditor
                                                                                    onFocus={(event) => {
                                                                                        getSuggestion(
                                                                                            "insta_rel_issue",
                                                                                            reportType
                                                                                        );
                                                                                    }}
                                                                                    setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                                    setOptions={SunEditorOpts}
                                                                                    onImageUploadBefore={onImageUploadBefore}
                                                                                    setContents={editorState13}
                                                                                    onChange={onEditorStateChange13}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </Row>
                                                                </Panel>

                                                            </Collapse>
                                                            <Row className="conclusion-section">
                                                                <div className="formGroup">
                                                                    <Form.Item
                                                                        label="Conclusion"
                                                                        name="conc_togg"
                                                                    >
                                                                        <Switch
                                                                            defaultChecked={
                                                                                props.isOpen.conclusionField === true &&
                                                                                    props.values.conc_togg === true
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            onChange={props.handleChange("conc_togg")}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                                {props.isOpen.conclusionField === true &&
                                                                    props.values.conc_togg === true ? (
                                                                    <div className="text-editor-wrapper">
                                                                        <SunEditor

                                                                            onFocus={(event) => {
                                                                                if (!props.values.disable_conclusion) {
                                                                                    getSuggestion('conclusion', reportType);
                                                                                }
                                                                            }}
                                                                            readOnly={props.values.disable_conclusion}
                                                                            setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                            setOptions={SunEditorOpts}
                                                                            onImageUploadBefore={onImageUploadBefore}
                                                                            setContents={editorState5}
                                                                            onChange={props.values.disable_conclusion ? noAction : onEditorStateChange5}

                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </Row>
                                                            <Row className="cause-section">
                                                                <div className="formGroup">
                                                                    <Form.Item label="Cause" name="cause_togg">
                                                                        <Switch
                                                                            defaultChecked={
                                                                                (props.values.cause_togg === true ||
                                                                                    props.isOpen.causeField === true) && props.values.disable_conclusion !== true
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            disabled={props.values.disable_conclusion}
                                                                            onChange={props.handleChange(
                                                                                "cause_togg"
                                                                            )}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                                {props.isOpen.causeField === true ||
                                                                    props.values.cause_togg === true ? (
                                                                    <div className="text-editor-wrapper">
                                                                        <SunEditor

                                                                            onFocus={(event) => {
                                                                                getSuggestion(
                                                                                    "cause",
                                                                                    reportType
                                                                                );
                                                                            }}
                                                                            setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                            setOptions={SunEditorOpts}
                                                                            onImageUploadBefore={onImageUploadBefore}
                                                                            setContents={editorState6}
                                                                            onChange={onEditorStateChange6}

                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Panel>

                                                <Panel
                                                    header={
                                                        <span>
                                                            Additional Details
                                                            <Tooltip
                                                                color="#0A497B"
                                                                title={
                                                                    <div style={{ padding: '6px 8px', borderRadius: '4px' }}>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px', borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '4px' }}>
                                                                            <InfoCircleFilled style={{ color: '#ffd666', fontSize: '13px' }} />
                                                                            <strong style={{ color: '#ffd666', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Important Notice</strong>
                                                                        </div>
                                                                        <p style={{ margin: 0, fontSize: '12px', lineHeight: '1.6', color: '#ffffff', fontWeight: '400' }}>
                                                                            <strong>Note:</strong> Information added to the Confidential section is intended for the commissioning party only. However, any portion of an inspection report, including confidential information, may potentially become discoverable during litigation.
                                                                        </p>
                                                                    </div>
                                                                }
                                                            >
                                                                <InfoCircleFilled style={{ marginLeft: 8, color: '#ffd666', fontSize: '17px', verticalAlign: 'middle', cursor: 'pointer', transition: 'transform 0.2s ease' }} />
                                                            </Tooltip>
                                                        </span>
                                                    }
                                                    key={7}
                                                    className="confidential-panel"
                                                >
                                                    <Col xs={24} md={24} xl={24}>
                                                        <div className="formGroup">
                                                            <Form.Item
                                                                label={
                                                                    <span>
                                                                        Has Additional Details Comments?
                                                                        <Tooltip
                                                                            color="#0A497B"
                                                                            title={
                                                                                <div style={{ padding: '6px 8px', borderRadius: '4px' }}>
                                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px', borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '4px' }}>
                                                                                        <InfoCircleFilled style={{ color: '#fa8c16', fontSize: '13px' }} />
                                                                                        <strong style={{ color: '#fa8c16', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Important Notice</strong>
                                                                                    </div>
                                                                                    <p style={{ margin: 0, fontSize: '12px', lineHeight: '1.6', color: '#ffffff', fontWeight: '400' }}>
                                                                                        <strong>Note:</strong> Information added to the Confidential section is intended for the commissioning party only. However, any portion of an inspection report, including confidential information, may potentially become discoverable during litigation.
                                                                                    </p>
                                                                                </div>
                                                                            }
                                                                        >
                                                                            <InfoCircleFilled style={{ marginLeft: 6, color: '#fa8c16', fontSize: '16px', verticalAlign: 'middle', cursor: 'pointer', transition: 'transform 0.2s ease' }} />
                                                                        </Tooltip>
                                                                    </span>
                                                                }
                                                                name="confi"
                                                            >
                                                                <Switch
                                                                    defaultChecked={
                                                                        props.values.confi === true ||
                                                                            props.isOpen.confidentialField === true
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    onChange={props.handleChange("confi")}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                        {props.isOpen.confidentialField === true ||
                                                            props.values.confi === true ? (
                                                            <div className="text-editor-wrapper">
                                                                <SunEditor

                                                                    onFocus={(event) => {
                                                                        getSuggestion(
                                                                            "confidential-information",
                                                                            reportType
                                                                        );
                                                                    }}
                                                                    setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                    setOptions={SunEditorOpts}
                                                                    onImageUploadBefore={onImageUploadBefore}
                                                                    setContents={editorState7}
                                                                    onChange={onEditorStateChange7}

                                                                />
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </Col>
                                                </Panel>
                                                <Panel header="Footer" key={8}>
                                                    <Col xs={24} md={24} xl={24}>
                                                        <Row
                                                            gutter={16}
                                                            className="footer-singnature-section"
                                                        >
                                                            <div className="formGroup">
                                                                <Form.Item
                                                                    label="Upload Signature"
                                                                    name="upload_sign_toggle"
                                                                >
                                                                    <Switch
                                                                        defaultChecked={
                                                                            props.values.upload_sign_toggle ===
                                                                                true ||
                                                                                props.isOpen.signatureField === true
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        onChange={props.handleChange(
                                                                            "upload_sign_toggle"
                                                                        )}
                                                                    />
                                                                </Form.Item>
                                                            </div>
                                                            {props.isOpen.signatureField === true ||
                                                                props.values.upload_sign_toggle === true ? (
                                                                <>
                                                                    <div className="image-wrapper">
                                                                        <Form.Item
                                                                            name="upload"
                                                                            valuePropName="fileList"
                                                                            getValueFromEvent={normFile}
                                                                        >
                                                                            <Upload
                                                                                name="avatar"
                                                                                listType="picture-card"
                                                                                className="avatar-uploader"
                                                                                showUploadList={false}
                                                                                customRequest={uploadImage}
                                                                                beforeUpload={beforeUpload}
                                                                                onChange={handleChangeImage}
                                                                            >
                                                                                {imageUrl ? (
                                                                                    <img
                                                                                        src={imageUrl}
                                                                                        alt="avatar"
                                                                                        style={{
                                                                                            width: "100%",
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    uploadButton
                                                                                )}
                                                                            </Upload>
                                                                        </Form.Item>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </Row>
                                                    </Col>
                                                    <Col xs={24} md={24} xl={24}>
                                                        <Row gutter={16}>
                                                            <div className="formGroup">
                                                                <Form.Item
                                                                    label="Footer Text"
                                                                    name="footer_text_info"
                                                                    valuePropName="checked"
                                                                >
                                                                    <Switch
                                                                        defaultChecked={
                                                                            props.values.footer_text_info === true ||
                                                                                props.isOpen.footerField === true
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        onChange={props.handleChange(
                                                                            "footer_text_info"
                                                                        )}
                                                                    />
                                                                </Form.Item>
                                                            </div>
                                                            {props.isOpen.footerField === true ||
                                                                props.values.footer_text_info === true ? (
                                                                <div className="text-editor-wrapper">
                                                                    <SunEditor

                                                                        onFocus={(event) => {
                                                                            getSuggestion(
                                                                                "footer-text",
                                                                                reportType
                                                                            );
                                                                        }}
                                                                        setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                                        setOptions={SunEditorOpts}
                                                                        onImageUploadBefore={onImageUploadBefore}
                                                                        setContents={editorState8}
                                                                        onChange={onEditorStateChange8}

                                                                    />
                                                                </div>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </Row>
                                                    </Col>
                                                </Panel>
                                            </Collapse>
                                        </Col>
                                        <Col xs={24} md={8} xl={8} className="sticySidebar">
                                            <Card className="custom-sidecard">
                                                <h5 className="formGroupTitle1">
                                                    Industry Standards and Citations
                                                </h5>
                                                <div className="searchWrapper">
                                                    <Input
                                                        prefix={<SearchOutlined />}
                                                        placeholder="Search for names.."
                                                        className="formControl"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                    <p>
                                                        Your citations will start appearing below when you click into any section of the report.
                                                    </p>
                                                    {loading ? (
                                                        <div className="spinDiv">
                                                            <SkeletonIndustryStandard />
                                                        </div>
                                                    ) : (
                                                        <div className="innerCardWrap">
                                                            {filterStandards && search
                                                                ? filterStandards?.map((item, index) => {
                                                                    return (
                                                                        <Card
                                                                            className="industryCard mb-2 sidebarCard"
                                                                            key={index}
                                                                        >
                                                                            <div className="industryCardBody">
                                                                                <div className="cardTopSection">
                                                                                    <div className="headerSec">
                                                                                        <h3
                                                                                            className="industryTitle"
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: item.title,
                                                                                            }}
                                                                                        ></h3>
                                                                                        <p
                                                                                            className="industryDesc"
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: item.excerpt,
                                                                                            }}
                                                                                        ></p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="contentSec">
                                                                                    <div className="btnGroup">
                                                                                        <Tooltip title="Copy/Paste">
                                                                                            <Button
                                                                                                type="text"
                                                                                                id={item.id}
                                                                                                className="indstryBtn viewBtn"
                                                                                                onClick={() =>
                                                                                                    sendTextToEditor(
                                                                                                        item.description,
                                                                                                        item.label
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                <CopyOutlined />
                                                                                            </Button>
                                                                                        </Tooltip>
                                                                                        <Tooltip title="Edit">
                                                                                            <Button
                                                                                                type="text"
                                                                                                id={item.id}
                                                                                                className="indstryBtn"
                                                                                            >
                                                                                                <FormOutlined />
                                                                                            </Button>
                                                                                        </Tooltip>
                                                                                        <Tooltip title="View More">
                                                                                            <Button
                                                                                                type="text"
                                                                                                id={item.id}
                                                                                                className="indstryBtn"
                                                                                                onClick={() =>
                                                                                                    handleClick(item.id)
                                                                                                }
                                                                                            >
                                                                                                <EyeOutlined />
                                                                                            </Button>
                                                                                        </Tooltip>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </Card>
                                                                    );
                                                                })
                                                                : sidebarState?.map((item, index) => {
                                                                    return (
                                                                        <Card
                                                                            className="industryCard mb-2 sidebarCard"
                                                                            key={index}
                                                                        >
                                                                            <div className="industryCardBody">
                                                                                <div className="cardTopSection">
                                                                                    <div className="headerSec">
                                                                                        <h3
                                                                                            className="industryTitle"
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: item.title,
                                                                                            }}
                                                                                        ></h3>
                                                                                        <p
                                                                                            className="industryDesc"
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: item.excerpt,
                                                                                            }}
                                                                                        ></p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="contentSec">
                                                                                    <div className="btnGroup">
                                                                                        <Tooltip title="Copy/Paste">
                                                                                            <Button
                                                                                                type="text"
                                                                                                id={item.id}
                                                                                                className="indstryBtn viewBtn"
                                                                                                onClick={() =>
                                                                                                    sendTextToEditor(
                                                                                                        item.description,
                                                                                                        item.label
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                <CopyOutlined />
                                                                                            </Button>
                                                                                        </Tooltip>
                                                                                        {/* <Tooltip title="Edit">
                                              <Button
                                                type="text"
                                                id={item.id}
                                                className="indstryBtn"
                                              >
                                                <FormOutlined />
                                              </Button>
                                            </Tooltip> */}
                                                                                        <Tooltip title="View More">
                                                                                            <Button
                                                                                                type="text"
                                                                                                id={item.id}
                                                                                                className="indstryBtn"
                                                                                                onClick={() =>
                                                                                                    handleClick(item.id)
                                                                                                }
                                                                                            >
                                                                                                <EyeOutlined />
                                                                                            </Button>
                                                                                        </Tooltip>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </Card>
                                                                    );
                                                                })}
                                                        </div>
                                                    )}
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>

                                <div className="attachmentSection">
                                    <div className="attachmentHead">
                                        <h4 className="formGroupTitle">Add Attachments</h4>
                                    </div>
                                    <Row className="custom-dropzone-row" gutter={16}>
                                        <Upload1
                                            takefileList={takefileList}
                                            values={props.values}
                                            handleFill={props.handleFill}
                                            setLoadings={props.setLoadings}
                                        ></Upload1>
                                    </Row>
                                </div>
                                <div className="attachmentSection">
                                    <div className="CertificationHead">
                                        <h4 className="formGroupTitle">Certification</h4>
                                    </div>
                                    <Row className="my-2 footerRow" gutter={6}>
                                        {Object.keys(footerLogo).map((keyName, index) => (
                                            <Form.Item name={[`footerLogo`, index]} key={index}>
                                                <Col className="col-auto h-100" key={index}>
                                                    <div className="logoDiv">
                                                        <input
                                                            type="checkbox"
                                                            id={footerLogo[keyName].logo_id}
                                                            name="logoSelect[]"
                                                            defaultChecked={selectedlogs?.includes(
                                                                footerLogo[keyName].logo_id?.toString()
                                                            )}
                                                            onChange={props.handleChange("footerLogo")}
                                                            style={{ backgroundColor: getFieldBgColor('footerLogo') }}
                                                            value={[footerLogo[keyName].logo_id]}
                                                        />

                                                        <label htmlFor={footerLogo[keyName].logo_id}>
                                                            <Image
                                                                src={footerLogo[keyName].logo_url}
                                                                className="img-fluid"
                                                                alt="logos"
                                                                preview={false}
                                                            />
                                                        </label>
                                                    </div>
                                                </Col>
                                            </Form.Item>
                                        ))}
                                    </Row>
                                </div>
                                <div className="attachmentSection">
                                    <div className="CertificationHead">
                                        <h4 className="formGroupTitle">Private Notes</h4>
                                    </div>
                                    <div className="p-3">
                                        <div className="formGroup">
                                            <Form.Item
                                                label="Private Notes"
                                                name="private_notes_togg"
                                            >
                                                <Switch
                                                    defaultChecked={
                                                        props.values.private_notes_togg === true ||
                                                            props.isOpen.notesField === true
                                                            ? true
                                                            : false
                                                    }
                                                    onChange={props.handleChange("private_notes_togg")}
                                                />
                                            </Form.Item>
                                        </div>
                                        {props.isOpen.notesField === true ||
                                            props.values.private_notes_togg === true ? (
                                            <div className="text-editor-wrapper">
                                                <SunEditor

                                                    onFocus={(event) => {
                                                        getSuggestion(
                                                            "private_notes",
                                                            reportType
                                                        );
                                                    }}
                                                    setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                                                    setOptions={SunEditorOpts}
                                                    onImageUploadBefore={onImageUploadBefore}
                                                    setContents={editorState9}
                                                    onChange={onEditorStateChange9}

                                                />
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </Form >

            <Modal
            className="grammar-check-modal"
            title={industryContent.title}
            centered
            open={modalIndustry}
            closable={true}
            onCancel={() => {
                setModalIndustry(false);
                // cleanup if necessary
                if (typeof window.closeGrammarModal === 'function') {
                try { window.closeGrammarModal(); } catch(e) {}
                }
            }}
            width="75%"
            footer={[]}
            >
            <div className="modalContent">
                <div className="formGroup">
                {industryContent && industryContent.description ? (
                    // If description is a string, render as HTML; otherwise render JSX/node directly
                    typeof industryContent.description === 'string' ? (
                    <div dangerouslySetInnerHTML={{ __html: industryContent.description }} />
                    ) : (
                    industryContent.description
                    )
                ) : (
                    // fallback content if description missing
                    <div style={{ padding: 12 }}>
                    <p>No content available.</p>
                    </div>
                )}
                </div>
            </div>
            </Modal>
        </>
    );
}

export default CommonFourthStep;
